import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Employees from './pages/Employees';
import Managers from './pages/Managers';
import Projects from './pages/Projects';
import Clients from './pages/Clients';
import Reports from './pages/Reports';
import Utilization from './pages/Utilization';
import PLI from './pages/PLI';
import './index.css';

const Guard = ({ children, roles }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
};

const Public = ({ children }) => {
  const { user } = useAuth();
  return user ? <Navigate to="/" replace /> : children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login"      element={<Public><Login /></Public>} />
      <Route path="/"           element={<Guard><Dashboard /></Guard>} />
      <Route path="/employees"  element={<Guard roles={['hr']}><Employees /></Guard>} />
      <Route path="/managers"   element={<Guard roles={['hr']}><Managers  /></Guard>} />
      <Route path="/projects"   element={<Guard roles={['hr']}><Projects /></Guard>} />
      <Route path="/clients"    element={<Guard roles={['hr']}><Clients /></Guard>} />
      <Route path="/reports"         element={<Guard roles={['hr','manager']}><Reports /></Guard>} />
      <Route path="/utilization"     element={<Guard roles={['hr']}><Utilization /></Guard>} />
      <Route path="/pli"             element={<Guard roles={['hr']}><PLI /></Guard>} />
      <Route path="*"                element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" toastOptions={{ style:{ background:'#1a1d27', color:'#e5e7eb', border:'1px solid #2a2d3a', borderRadius:10, fontSize:13 }, success:{ iconTheme:{ primary:'#10b981', secondary:'#1a1d27' }}, error:{ iconTheme:{ primary:'#ef4444', secondary:'#1a1d27' }}}} />
      </BrowserRouter>
    </AuthProvider>
  );
}